import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N } from "@sundae/react-hooks";
import { StackIcon, Text } from "@sundae/ui-toolkit";
export const ProposalNotFound = () => {
    const { t } = useI18N();
    return (_jsxs(_Fragment, { children: [_jsx(StackIcon, { width: 75, height: 75, className: "mx-auto mb-8" }), _jsx(Text, { tag: "h4", size: "3xl", weight: "bold", children: t("errors.proposals.not_found_title") }), _jsx(Text, { tag: "p", children: t("errors.proposals.not_found_description") })] }));
};
export default ProposalNotFound;
//# sourceMappingURL=ProposalNotFound.js.map